import types from '../../../helpers/textureTypes';

const defaultValues = {
  singleBrushTexturesType: types.HALF_FLOAT,
  singleBrushTexturesFilter: types.LINEAR,
  doubleBrushTexturesType: types.FLOAT,
  doubleBrushTexturesFilter: types.LINEAR,
  tripleBrushTexturesType: types.HALF_FLOAT,
  tripleBrushTexturesFilter: types.LINEAR,

  brushVelocitiesTexturesType: types.HALF_FLOAT,
  brushVelocitiesTexturesFilter: types.LINEAR,
  splatTexturesType: types.HALF_FLOAT,
  splatTexturesFilter: types.LINEAR,
  randomTexturesFilter: types.LINEAR,

  howManyLayers: 1,
  maxTextureSize: 2048,
};

const numberKeys = ['howManyLayers', 'maxTextureSize'];

const getDefaultTextureValues = () => {
  const keys = Object.keys(defaultValues);
  const values = Object.values(types);

  const obj = {};

  for (let i = 0; i < keys.length; i++) {
    const fromLocalStorage = localStorage.getItem(keys[i]);

    if (fromLocalStorage && values.includes(fromLocalStorage)) {
      obj[keys[i]] = fromLocalStorage;
    } else {
      if (numberKeys.includes(keys[i])) {
        const value = parseInt(fromLocalStorage);

        obj[keys[i]] = Number.isInteger(value) ? value : defaultValues[keys[i]];
      } else {
        obj[keys[i]] = defaultValues[keys[i]];
      }
    }
  }

  return obj;
};

export default getDefaultTextureValues;
